<app-header></app-header>

<main class="min-h-screen">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
